<template>
  <div class="cactusButtonIcon">
    <div v-if="!routeDestination" @click="btnClicked">
      <img :src="getImgUrl(icon)" alt="icon" />
      <div class="textContent">
        <slot />
      </div>
    </div>

    <div v-if="routeDestination" @click="gotoRoute(routeDestination)">
      <img :src="getImgUrl(icon)" alt="icon" />
      <div class="textContent">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CactusButtonIcon',
  props: {
    useRouter: {
      type: Boolean,
      default: false
    },
    routeDestination: String,
    buttonText: String,
    icon: String
  },
  methods: {
    btnClicked() {
      this.$emit('btnClicked');
    },

    gotoRoute(route) {
      this.$router.push(route);
    },

    getImgUrl(img) {
      try {
        return require(`../../assets/img/ico-${img}.svg`);
      } catch (error) {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cactusButtonIcon {
  display: inline-block;
  cursor: pointer;

  img {
    margin-bottom: 3px;
  }

  .textContent {
    @include textSmall;
    color: $charcoal-grey;
  }
}

button {
  @include textCharts;
  display: inline-block;
  border-radius: 8px;
  background-color: $cloudy-blue;
  border: none;
  color: $petrol;
  width: $maxWidth * 0.9;
  height: 48px;
  line-height: 48px;
  cursor: pointer;
  margin-bottom: 10px;

  &.primary {
    background-color: $greeny-blue;
    color: white;
  }

  > * {
    display: block;
    color: inherit;
    width: 100%;
    height: 100%;
  }
}
</style>
